import { render, staticRenderFns } from "./TenantSettings.vue?vue&type=template&id=69b7b594&"
import script from "./TenantSettings.vue?vue&type=script&lang=js&"
export * from "./TenantSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports